export class SalifyRegex {
  static code = /^[A-Za-z0-9_-]+$/;
  static phoneNumber = /^0\d{9}$/;
}
